export default __webpack_public_path__ + "static/media/team3.7b1a41b0.jpg";